import React, { useEffect, useState, useCallback } from 'react';
import { Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import TechnicalUploadsForm from '@components/shared/technical_uploads/TechnicalUploadsForm';
import { Table } from '@rd-web-markets/shared/dist/util';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import projectDocumentationService from '@rd-web-markets/market/dist/services/elster/project_documentation.service';
const ProjectDocumentationTab = _ref => {
  let {
    claimProjectReport,
    handleToaster,
    setProjectReports,
    projectReports
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    uploads,
    upload,
    deleteFile,
    loading
  } = projectDocumentationService.useCrud(claimProjectReport, setProjectReports, handleToaster);
  if (!uploads) return /*#__PURE__*/React.createElement(Loading, null);
  const rows = upload => {
    return {
      key: upload.id,
      columns: [/*#__PURE__*/React.createElement("a", {
        rel: "noreferrer",
        href: upload?.document?.url,
        target: "_blank"
      }, /*#__PURE__*/React.createElement("small", null, upload.document.filename)), upload.comments, upload.uploaded_by, createTimezonedDate(new Date(upload.created_at)).toCustomLocaleDateString()],
      onDelete: () => deleteFile(upload.id)
    };
  };
  const headers = [{
    text: t('document_name')
  }, {
    text: t('document_comments')
  }, {
    text: t('uploaded_by')
  }, {
    text: t('date')
  }, {
    text: ''
  }];
  const tableRows = uploads.map(rows);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary mb-4"
  }, t('upload_document')), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(TechnicalUploadsForm, {
    handleSubmit: upload,
    loading: loading,
    showDocumentType: false
  }), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: tableRows,
    onDelete: (index, row) => deleteFile(row.key)
  }))));
};
export default ProjectDocumentationTab;